import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  message?: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  /** @deprecated use message */
  title?: string;
}

export default function EmptyState({ message, title, description, icon, action }: EmptyStateProps) {
  const main = message || title || '暂无数据';
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-14 h-14 rounded-full bg-slate-100 flex items-center justify-center text-slate-400 mb-3">
        {icon ?? <Inbox className="w-7 h-7" />}
      </div>
      <p className="text-sm font-medium text-slate-600">{main}</p>
      {description && <p className="text-xs text-slate-400 mt-1 text-center max-w-xs">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
